import { Tooltip } from '@ui/components/core'
import { NavigationLink } from '@ui/interfaces/navigation'
import clsx from 'clsx'

interface SideBarContentProps {
  links: NavigationLink[]
  manageLinks: NavigationLink[]
  expanded: boolean
}

const NavItem = ({ item, expanded }: { item: NavigationLink; expanded: boolean }) => {
  // if item is a function, invoke it to get the actual item
  let navItem: NavigationLink
  if (typeof item === 'function') {
    const _navItem: NavigationLink | null = item()
    if (!_navItem) return null
    navItem = _navItem
  } else {
    navItem = item
  }

  return (
    <Tooltip text={navItem.name} disabled={expanded}>
      <div
        key={navItem.name}
        onClick={navItem.onClick}
        className={clsx(
          'group flex cursor-pointer items-start rounded-md p-2 text-base transition-all duration-300 hover:bg-gray-100',
          {
            'bg-primary-100': navItem.current,
            'justify-center': !expanded,
            'justify-start space-x-2': expanded,
          }
        )}>
        <navItem.icon
          className={clsx(
            'my-auto size-5 shrink-0 stroke-1',
            navItem.current
              ? 'stroke-primary-600 text-primary-600'
              : 'stroke-black text-black group-hover:stroke-primary-600'
          )}
          aria-hidden="true"
        />
        <p className={navItem.current ? 'text-primary-600' : 'text-gray-900 group-hover:text-primary-600'}>
          {expanded && navItem.name}
        </p>
      </div>
    </Tooltip>
  )
}

export const SideBarContent = ({ links, manageLinks, expanded }: SideBarContentProps) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-between py-2">
      <div className={clsx('flex w-full flex-col gap-2', expanded ? 'px-4' : 'px-2')}>
        {links.map((link) => (
          <NavItem key={link.name} item={link} expanded={expanded} />
        ))}
      </div>
      <div className={clsx('flex w-full flex-col gap-2', expanded ? 'px-4' : 'px-2')}>
        {manageLinks.map((link) => (
          <NavItem key={link.name} item={link} expanded={expanded} />
        ))}
      </div>
    </div>
  )
}
